import styled, { css } from 'styled-components';
import _Section from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Section';
import BackgroundDesktop from './images/background-desktop-2x-min.png';
import BackgroundMobile from './images/background-mobile-4x-min.png';
import BackgroundTablet from './images/background-tablet-2x-min.png';

export const Section = styled(_Section)(
  ({ theme }) => css`
    height: 2700px;
    padding-top: ${theme.sz.s10};
    padding-bottom: ${theme.sz.s10};
    background-color: ${theme.co.neutral0};
    background-image: url(${BackgroundMobile});
    background-position-x: center;
    background-position-y: top;
    background-repeat: no-repeat;
    background-size: 860px 2700px;

    @media (min-width: ${theme.sz.md}) {
      background-image: url(${BackgroundTablet});
      background-size: 1152px 2700px;
    }

    @media (min-width: 1152px) {
      height: 1316px;
      background-image: url(${BackgroundDesktop});
      background-size: 1440px 1316px;
    }
  `,
);

export const SectionContent = styled(_Section.Content)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s6};

    @media (min-width: 1152px) {
      flex-direction: row;
    }
  `,
);
